import { React } from "react";
import { useState, useEffect, useRef } from "react";
import Wrapper from "../../components/UI/Wrapper";
import axios from "axios";
import "../../components/LeadPaymentDetails/LeadPaymentDetails.css";
import search from "../../images/Search.png";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import JSZip from "jszip";
import nextPage from "../../images/nextPage.svg";
import showDoc from "../../images/showDoc.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const LeadPaymentDetails = ({ Relocation_Id, isEditMode, setIsEditMode, module }) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const [currency, setCurrency] = useState("");
  const location = useLocation();
  const [paymentReceiptResponse, setpaymentReceiptResponse] = useState([]);
  const [leadDetailResponse, setLeadDetailResponse] = useState([]);
  const [decryptionError, setDecryptionError] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const gradientColors = ["#F15843", "#A3519F", "#5B489D"];
  const [latestPaymentReceiptId, setLatestPaymentReceiptId] = useState("");

  // Fetch rows data from the API
  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetPaymentReceipts?relocation_id=` + Relocation_Id,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setpaymentReceiptResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
    getPaymentInfo();
  }, []);

  const [firstItem, setFirstItem] = useState({
    relocation_id: "",

    Quotation: "",
    Amount_In_AED: "",
    Payment_Ter: "",
    Token_Payment: "",
    Remaining_Payment: "",
    Pymt_Status: "",
    Payment_Mode: "Bank",
    Estimate_Id: "",
    GST: "",
    amount_exc_gst: "",
    refund_amount: "",

    payment_mode: "Bank",
    amount: "",
    date_of_payment: "",
    document_path: "",
    doc_name: "",
    remark_Doc: "",
    priority_upload: "2",
    transaction_type: "1",
  });

  function setPaymentDetail(e) {
    const paymentPercentage = (e.Token_Payment / e.Quotation) * 100;
    const Payment_Ter = paymentPercentage.toFixed(1);
    const Remaining_Payment = e.Quotation - e.Token_Payment;

    setFirstItem((prevItem) => ({
      ...prevItem,

      Quotation: e.Quotation,
      Amount_In_AED: e.Amount_In_AED,
      Payment_Ter,
      Token_Payment: e.Token_Payment,
      Remaining_Payment,
      Pymt_Status: e.Pymt_Status,
      Payment_Mode: e.Payment_Mode,
      Estimate_Id: e.Estimate_Id,
      GST: e.GST,
      amount_exc_gst: e.amount_exc_gst,
      refund_amount: e.refund_amount,
    }));
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  function getPaymentColor(Pymt_Status) {
    switch (Pymt_Status) {
      case "Partial":
        return "yellow";
      case "Received":
        return "#28A745";
      case "Pending":
        return "orange";
      default:
        return "white";
    }
  }

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      setDecryptionError(true);

      return null;
    }
  }

  async function getDocument(Relocation_ID) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      try {
        const response = await axios.get(
          `${baseAPI}userget/GetPaymentReceipts?relocation_id=${Relocation_ID}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (response && response.data && response.data.data.length > 0) {
          setpaymentReceiptResponse(response.data.data);
          const latestReceipt = Math.max(
            ...response.data.data.map((item) => item.payment_receipt_id)
          );
          setLatestPaymentReceiptId(latestReceipt);
          return latestReceipt; // ✅ Correctly returned here
        } else {
          return null;
        }
      } catch (error) {
        console.error("Error fetching user detail:", error);
        return null;
      }
    }
    return null;
  }



  function getPaymentInfo() {
    setFirstItem((prevItem) => ({
      ...prevItem,
      relocation_id: Relocation_Id,
    }));

    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (baseAPI.includes("aeapi")) {
      setCurrency("INR");
    } else {
      setCurrency("AED");
    }
    if (storedToken) {
      axios
        .get(`${baseAPI}userget/GetLeadDetail?relocation_id=` + Relocation_Id, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setLeadDetailResponse(response.data.data);

          setFirstItem(prev => ({
            ...prev,
            ...response.data.data,
            payment_mode: prev.payment_mode || "Bank",
            transaction_type: prev.transaction_type || "1",
          }));


          if (
            response.data.data.paymentDetail != null &&
            response.data.data.paymentDetail != "" &&
            response.data.data.status == 3
          ) {
            setPaymentDetail(response.data.data.paymentDetail[0]);
          } else if (
            response.data.data.secpaymentDetail != null &&
            response.data.data.secpaymentDetail != ""
          ) {
            setPaymentDetail(response.data.data.secpaymentDetail[0]);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  async function deleteDoc(payment_receipt_id) {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this document?"
    );
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    if (isConfirmed) {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.delete(
        `${baseAPI}userpost/DeletePaymentReceipt`,
        {
          data: { payment_receipt_id: payment_receipt_id }, // Send request body
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      getDocument(Relocation_ID);
    }
  }

  function getUpdatedImage(file, name) {
    if (file) {
      setFirstItem({
        ...firstItem,
        [name]: file, // Store the file object directly
      });
    }
  }

  function isValidFileType(file) {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "application/vnd.ms-excel", // XLS
      "video/mp4",
      "video/x-msvideo", // AVI
      "video/x-matroska", // MKV
      "video/quicktime", // MOV
      "application/zip", // ZIP
      "application/x-zip-compressed", // Alternate ZIP MIME type
    ];
    return file && allowedTypes.includes(file.type);
  }

  function validateZipFile(file, name, e) {
    const reader = new FileReader();
    reader.onload = function (event) {
      const zipData = event.target.result;

      // Perform ZIP content validation here
      // This might include extracting the files, verifying file types, etc.
      // Client-side libraries like JSZip can help inspect ZIP files
      try {
        const jszip = new JSZip();
        jszip.loadAsync(zipData).then((zip) => {
          const allowedExtensions = ["jpg", "png", "pdf", "docx", "xlsx"];
          let isValid = true;

          zip.forEach((relativePath, zipEntry) => {
            const extension = relativePath.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(extension)) {
              isValid = false;
            }
          });

          if (isValid) {
            getUpdatedImage(file, name);
          } else {
            alert("ZIP file contains unsupported file types.");
            e.target.value = null;
          }
        });
      } catch (error) {
        alert("Error reading ZIP file.");
        e.target.value = null;
      }
    };

    reader.readAsArrayBuffer(file);
  }

  function handleChangeDoc(e) {
    const { name, value, files } = e.target;

    if (name === "doc_name") {
      const file = files[0];
      if (file.size > 50 * 1024 * 1024) {
        alert("File size exceeds 50 MB limit.");
        e.target.value = null;
        return;
      }

      if (isValidFileType(file)) {
        if (
          file.type === "application/zip" ||
          file.type === "application/x-zip-compressed"
        ) {
          validateZipFile(file, name, e);
        } else {
          getUpdatedImage(file, name);
        }
      } else {
        alert("Unsupported file type. Please upload a valid file.");
        // Reset the file input field
        e.target.value = null;
        return;
      }
    } else {
      setFirstItem({
        ...firstItem,
        [name]: value,
      });
    }
  }

  const uploadDocument = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (firstItem.transaction_type === "1" && !firstItem.doc_name) {
      alert("Please upload payment receipt for Payment Received.");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);

    // Append form fields and the file to FormData
    formData.append("relocation_id", Relocation_ID);
    formData.append("payment_mode", firstItem.payment_mode);
    formData.append("amount", firstItem.amount);
    formData.append("date_of_payment", firstItem.date_of_payment);
    formData.append("remark_Doc", firstItem.remark_Doc);
    formData.append("priority_upload", 2);
    formData.append("transaction_type", firstItem.transaction_type);

    if (firstItem.doc_name) {
      formData.append("doc_name", firstItem.doc_name);
    }

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}userpost/UploadPaymentReceiptData`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "multipart/form-data", // Ensure you're sending form data
          },
        }
      );

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      const latestReceiptId = await getDocument(Relocation_ID);
      sendPaymentReceiptMail(
        Relocation_ID,
        leadDetailResponse.first_name,
        firstItem.amount,
        firstItem.payment_mode,
        leadDetailResponse.name,
        latestReceiptId,
        firstItem.transaction_type
      );

      // Reset after success

      setFirstItem((prevItem) => ({
        ...prevItem,
        payment_mode: "Bank",
        amount: "",
        date_of_payment: "",
        remark_Doc: "",
        document_path: "",
        doc_name: "",
        priority_upload: "2",
        transaction_type: "1",
      }));

      toast.success("Receipt has been uploaded", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      console.error("Error posting data:", error);
    } finally {
      setLoading(false);
    }
  };

  const sendPaymentReceiptMail = async (relocation_id, custName, paymentAmount,
    paymentMode, salesCoordinator, payment_receipt_ID, transaction_type) => {
    const documentObj = {
      relocationID: relocation_id,
      custName: custName,
      paymentAmount: paymentAmount,
      paymentMode: paymentMode,
      salesCoordinator: salesCoordinator,
      payment_receipt_id: payment_receipt_ID,
      transaction_type: transaction_type
    };

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}userpost/SendPaymentReceiptUploadMail`,
        documentObj,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };


  const handleClick = (e) => {
    e.preventDefault();
    handleSubmit();
    setIsEditMode(false);
  };

  const handleSubmit = async () => {
    try {
      await handleSecPaymentDetail();
      if (leadDetailResponse.leadUpdatedetail[0].closedleadstage === 47 || leadDetailResponse.leadUpdatedetail[0].closedleadstage === "47") {
        await handlePaymentDetail();
      }
      getPaymentInfo();

      toast.success("Data Saved Successfully!!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });


    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const handlePaymentDetail = async () => {
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint

      const response = await axios.post(
        `${baseAPI}userpost/UpdatePaymentDetail`,
        firstItem,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  const handleSecPaymentDetail = async () => {
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint

      const response = await axios.post(
        `${baseAPI}userpost/UpdateSecPaymentDetail`,
        firstItem,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  function encryptRelocationID(Relocation_ID, key) {
    const ciphertext = CryptoJS.AES.encrypt(Relocation_ID.toString(), key).toString();
    return encodeURIComponent(ciphertext);
  }

  function nextPage1(payment_receipt_id) {
    const key = 'dbbworldwidepvtltd';
    const encryptedRelocationID = encryptRelocationID(payment_receipt_id, key);
    const url = `/PaymentReceiptInfo?payment_receipt_id=${encryptedRelocationID}`;
    window.open(url, '_blank');
  }

  const transactionStyleMap = {
    "Payment Received": {
      bg: "#E8F7EF",
      text: "#1E8E5A"
    },
    "Partial Refund": {
      bg: "#FFF4E5",
      text: "#E67E22"
    },
    "Full Refund": {
      bg: "#FDECEA",
      text: "#D93025"
    },
    "Refund with Cancellation Charges": {
      bg: "#F3E8FF",
      text: "#7B3FE4"
    }
  };

  const numberToWords = (num) => {
    const units = [
      "Zero",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const thousands = ["", "Thousand", "Million", "Billion"];

    // 🚨 Guard: handle invalid numbers
    if (num == null || num === "" || isNaN(num)) {
      return "";
    }

    num = Number(num);

    if (num === 0) return "Zero";

    const convertToWords = (n) => {
      if (n < 10) return units[n];
      if (n < 20) return teens[n - 10];
      if (n < 100)
        return tens[Math.floor(n / 10)] + (n % 10 ? " " + units[n % 10] : "");
      if (n < 1000) {
        return (
          units[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 ? " " + convertToWords(n % 100) : "")
        );
      }
      for (let i = 0; i < thousands.length; i++) {
        const unit = 1000 ** i;
        if (n < unit * 1000) {
          return (
            convertToWords(Math.floor(n / unit)) +
            " " +
            thousands[i] +
            (n % unit ? " " + convertToWords(n % unit) : "")
          );
        }
      }
    };

    // ✅ Handle decimals safely
    if (!Number.isInteger(num)) {
      let [integerPart, decimalPart] = num.toString().split(".");
      let decimalWords = decimalPart
        .split("")
        .map((digit) => units[parseInt(digit)])
        .join(" ");
      return `${convertToWords(parseInt(integerPart))} Point ${decimalWords}`;
    }

    return convertToWords(num);
  };


  return (
    <>
      <Wrapper className="LeadDetails">
        <div>
          <ToastContainer />
          {/* {isEditMode ? (
            <>
              <div className="viewLeadDetails-form">
                <table
                  style={{
                    width: "100%",
                    color: "#6A6A6A",
                    borderRadius: "5px",
                  }}
                >
                  <tr className="viewLeadDetailsHeading">
                    <th
                      colSpan={4}
                      style={{
                        background: "#5B489D",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      <span style={{ fontSize: "18px" }}> Payment Details </span>
                    </th>
                  </tr>
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Quotation Amount</span>
                    </th>
                    <td>
                      <input
                        className="form-control"
                        type="number"
                        name="Quotation"
                        value={firstItem.Quotation}
                        // onChange={handleChange}
                        disabled
                      />
                    </td>
                    <th>
                      <span>Quotation Amount ({currency})</span>
                    </th>
                    <td>
                      <input
                        className="form-control"
                        type="number"
                        name="Amount_In_AED"
                        value={firstItem.Amount_In_AED}
                          // onChange={handleChange}
                        disabled
                      />
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Token Payment</span>
                    </th>
                    <td>
                      <input
                        className="form-control"
                        type="number"
                        name="Token_Payment"
                        value={firstItem.Token_Payment}
                         // onChange={handleChange}
                        disabled
                      />
                    </td>
                    <th>
                      <span>Remaining Payment</span>
                    </th>
                    <td>
                      <span>{firstItem.Remaining_Payment}</span>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Payment (%)</span>
                    </th>
                    <td>
                      <span>{firstItem.Payment_Ter} %</span>
                    </td>
                    <th>
                      <span>Payment Status</span>
                    </th>
                    <td>
                      <span
                        style={{
                          padding: "6px",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                          backgroundColor: getPaymentColor(firstItem.Pymt_Status),
                        }}
                      >
                        {firstItem.Pymt_Status}
                      </span>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Payment Mode</span>
                    </th>
                    <td>
                      <select
                        className="form-control"
                        name="Payment_Mode"
                        value={firstItem.Payment_Mode}
                          // onChange={handleChange}
                        disabled
                      >
                        <option>Please Select*</option>
                        <option value="Razorpay">Razorpay</option>
                        <option value="Bank">Bank</option>
                        <option value="Cash">Cash</option>
                        <option value="Both">Both</option>
                      </select>
                    </td>
                    <th>
                      <span>Estimate ID</span>
                    </th>
                    <td>
                      <input
                        className="form-control"
                        type="text"
                        name="Estimate_Id"
                        value={firstItem.Estimate_Id}
                        // onChange={handleChange}
                        disabled
                      />
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>GST</span>
                    </th>
                    <td>
                      <input
                        className="form-control"
                        type="number"
                        name="GST"
                        value={firstItem.GST}
                        // onChange={handleChange}
                        disabled
                      />
                    </td>
                    <th>
                      <span>Amount Excluding GST</span>
                    </th>
                    <td>
                      <input
                        className="form-control"
                        type="number"
                        name="amount_exc_gst"
                        value={firstItem.amount_exc_gst}
                        // onChange={handleChange}
                        disabled
                      />
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Refund Amount (If any)</span>
                    </th>
                    <td>
                      <input
                        className="form-control"
                        type="number"
                        name="refund_amount"
                        value={firstItem.refund_amount}
                        // onChange={handleChange}
                        disabled
                      />
                    </td>
                    <th>
                      <span></span>
                    </th>
                    <td>
                      
                    </td>
                  </tr>



                </table>
              </div>
              <div
                id="divSubmit"
                style={{ display: "flex", flexDirection: "row-reverse" }}
              >
                {decryptionError ? (
                  <p>Error </p>
                ) : (
                  <>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setIsEditMode(false)}
                    >
                      Cancel
                    </button>




                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleClick}
                      style={{
                        background: `linear-gradient(to right, ${gradientColors.join(
                          ", "
                        )})`,
                      }}
                    >
                      Update
                    </button>
                  </>
                )}
                <ToastContainer />
              </div>
            </>
          ) : ( */}
          <div className="viewLeadDetails-form">
            <table
              style={{
                width: "100%",
                color: "#6A6A6A",
                borderRadius: "5px",
              }}
            >
              <tr className="viewLeadDetailsHeading">
                <th
                  colSpan={4}
                  style={{
                    background: "#5B489D",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  <span style={{ fontSize: "18px" }}> Payment Details </span>
                </th>
              </tr>

              <tr className="viewLeadDetailsHeading">
                <th>
                  <span>Quotation Amount</span>
                </th>
                <td>
                  <span>{firstItem.Quotation}</span>
                </td>
                <th>
                  <span>Quotation Amount ({currency})</span>
                </th>
                <td>
                  <span>{firstItem.Amount_In_AED}</span>
                </td>
              </tr>

              <tr className="viewLeadDetailsHeading">
                <th>
                  <span>Payment Received</span>
                </th>
                <td>
                  <span>{firstItem.Token_Payment}</span>
                </td>
                <th>
                  <span>Remaining Payment</span>
                </th>
                <td>
                  <span>{firstItem.Remaining_Payment}</span>
                </td>
              </tr>

              <tr className="viewLeadDetailsHeading">
                <th>
                  <span>Payment (%)</span>
                </th>
                <td>
                  <span>{firstItem.Payment_Ter} %</span>
                </td>
                <th>
                  <span>Payment Status</span>
                </th>
                <td>
                  <span
                    style={{
                      padding: "6px",
                      color: "black",
                      fontWeight: "bold",
                      textAlign: "center",
                      backgroundColor: getPaymentColor(firstItem.Pymt_Status),
                    }}
                  >
                    {firstItem.Pymt_Status}
                  </span>
                </td>
              </tr>

              <tr className="viewLeadDetailsHeading">
                <th>
                  <span>Payment Mode</span>
                </th>
                <td>
                  <span>{firstItem.Payment_Mode}</span>
                </td>
                <th>
                  <span>Estimate ID</span>
                </th>
                <td>
                  <span>{firstItem.Estimate_Id}</span>
                </td>
              </tr>
              <tr className="viewLeadDetailsHeading">
                <th>
                  <span>GST</span>
                </th>
                <td>
                  <span>{firstItem.GST}</span>
                </td>
                <th>
                  <span>Amount Excluding GST</span>
                </th>
                <td>
                  <span>{firstItem.amount_exc_gst}</span>
                </td>
              </tr>
              <tr className="viewLeadDetailsHeading">
                <th>
                  <span>Refund Amount (if any)</span>
                </th>
                <td>
                  <span>{firstItem.refund_amount}</span>
                </td>
                <th>
                  <span></span>
                </th>
                <td>
                  <span></span>
                </td>
              </tr>
            </table>
            {/* {module === "accounts" && (
                <>
                  <div
                    style={{ display: "flex", flexDirection: "row-reverse" }}
                  >
                    {decryptionError ? (
                      <p>Error </p>
                    ) : (
                      <>

                        <button
                          type="button"
                          className="btn btn-primary"
                          // onClick={() => setIsEditMode(true)}
                          style={{
                            background: `linear-gradient(to right, ${gradientColors.join(
                              ", "
                            )})`,
                          }}
                        >
                          Edit
                        </button>
                      </>
                    )}
                  </div>
                </>
              )} */}
          </div>
          {/* )} */}
        </div>
      </Wrapper>
      <br />
      {module === "sales" && (
        <>
          <Wrapper>
            <div>
              <div className="viewLeadDetails-form">
                <table
                  style={{
                    width: "100%",
                    color: "#6A6A6A",
                    borderRadius: "5px",
                  }}
                >
                  <tr className="viewLeadDetailsHeading">
                    <th
                      colSpan={4}
                      style={{
                        background: "#5B489D",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      <span style={{ fontSize: "18px" }}> Payment Confirmation/Refund Request </span>
                    </th>
                  </tr>
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Transaction type</span>
                    </th>
                    <td>
                      <select
                        className="form-control"
                        name="transaction_type"
                        value={firstItem.transaction_type}
                        onChange={handleChange}
                      >
                        <option value="1">Payment Received</option>
                        <option value="2">Partial Refund</option>
                        <option value="3">Full Refund</option>
                        <option value="4">Refund with Cancellation Charges</option>
                      </select>
                    </td>
                    <th>
                      Total in words
                    </th>
                    <td>
                      {numberToWords(Math.round(firstItem.amount))}
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Payment Mode</span>
                    </th>
                    <td>
                      <select
                        className="form-control"
                        name="payment_mode"
                        value={firstItem.payment_mode}
                        onChange={handleChange1}
                      >
                        <option>Please Select*</option>
                        <option value="Razorpay">Razorpay</option>
                        <option value="Bank">Bank</option>
                        <option value="Cash">Cash</option>
                        <option value="Both">Both</option>
                      </select>
                    </td>
                    <th>
                      <span>Amount</span>
                    </th>
                    <td>
                      <input
                        className="form-control"
                        type="number"
                        name="amount"
                        value={firstItem.amount}
                        onChange={handleChange}
                        onWheel={(e) => e.target.blur()}
                      />
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>
                        {firstItem.transaction_type === "1"
                          ? "Date of Payment Received"
                          : "Date of Refund Request"}
                      </span>
                    </th>
                    <td>
                      <input
                        className="form-control"
                        type="date"
                        name="date_of_payment"
                        value={firstItem.date_of_payment}
                        onChange={handleChange}
                      />
                    </td>
                    <th>
                      <span>Upload Payment Receipt</span>
                    </th>
                    <td>
                      <input
                        id="doc_name"
                        type="file"
                        name="doc_name"
                        onChange={handleChangeDoc}
                        ref={fileInputRef}
                        required
                        className="form-control"
                        style={{ width: "-webkit-fill-available" }}
                        disabled={firstItem.transaction_type !== "1"}
                      />
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Remark</span>
                    </th>
                    <td colSpan={3}>
                      <div
                        className="row"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          height: "70px",
                        }}
                      >
                        <div className="col-10">
                          <input
                            // className="form-control"
                            type="text"
                            name="remark_Doc"
                            value={firstItem.remark_Doc}
                            onChange={handleChange}
                            style={{ width: "100%", height: "32px" }}
                          />
                        </div>
                        <div className="col-2">
                          <button
                            style={{
                              backgroundColor: "#5B489D",
                              color: "white",
                              width: "93%",
                              // margin: "7px",
                            }}
                            className="btn btn-success inputDoc3"
                            onClick={uploadDocument}
                          >
                            Upload

                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </Wrapper>
          <br />
        </>)}

      <Wrapper>
        <div>
          <div className="viewLeadDetails-form">
            <table
              style={{
                width: "100%",
                color: "#6A6A6A",
                borderRadius: "5px",
              }}
            >
              <tr className="viewLeadDetailsHeading">
                <th
                  colSpan={4}
                  style={{
                    background: "#5B489D",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  <span style={{ fontSize: "18px" }}> Payment History</span>
                </th>
              </tr>
            </table>
          </div>
          {paymentReceiptResponse !== null
            ? paymentReceiptResponse.map((item, index) => (
              <>
                <div
                  style={{
                    border: "1px solid #DEE2E6",
                    height: "130px",
                    borderRadius: "10px",
                    marginBottom: "-55px",
                    backgroundColor: "white",
                  }}
                >
                  <table className="paymentHistory">
                    <tr style={{ backgroundColor: "#F0EBFF" }}>
                      {/* <th style={{ width: "16%" }}>
                        <div style={{ color: "#F0EBFF" }}>Payment Receipt</div>
                      </th> */}
                      <th style={{ width: "16%" }}>{++index}</th>
                      <th>Updated Payments by Accounts(if Any)</th>
                      <th>Uploaded Date and Time</th>
                      <th>Payment Mode</th>
                      <th>UTR Number</th>
                      <th>Status</th>
                      <th>Remark</th>
                      <th>Document by Accounts Team</th>
                      {module === "sales" && <th>Action</th>}

                    </tr>

                    <tr>
                      <td></td>
                      <td>{item.UpdatedAmount}</td>
                      <td>{item.created_date}</td>

                      <td>{item.payment_mode}</td>
                      <td style={{ maxWidth: "10rem", padding: "4px", overflow: "hidden" }}>{item.UTR_Number}</td>
                      <td
                        style={{
                          color: item.is_verified === 0 ? "#FFA500" : "#20BF44",
                        }}
                      >
                        {item.is_verified === 0 ? "Requested" : "Verified"}
                      </td>
                      <td >{item.remark_Doc}</td>


                      <td >
                        <a
                          style={{
                            color: "#6a6a6a",
                            textDecoration: "none",
                            cursor: "pointer",
                            fontWeight: "bold",
                            pointerEvents: item.uploaded_doc_name ? "auto" : "none",
                            opacity: item.uploaded_doc_name ? 1 : 0.5,
                          }}
                          target="_blank"
                          href={item.uploaded_doc_name ? `${baseImageURL}Images/Documents/${item.relocation_id}/${item.uploaded_doc_name}` : "#"}
                          rel="noopener noreferrer"
                        >
                          View Document
                        </a>
                      </td>
                      {module === "sales" &&
                        <td style={{ display: "flex" }}>
                          <a
                            style={{
                              color: "#6a6a6a",
                              textDecoration: "none",
                              cursor: "pointer",
                              fontWeight: "bold",
                              pointerEvents: item.doc_name ? "auto" : "none",
                              opacity: item.doc_name ? 1 : 0.5,
                            }}
                            target="_blank"
                            href={item.doc_name ? `${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}` : "#"}
                            rel="noopener noreferrer"
                          >
                            <img src={nextPage} alt="search" />
                          </a>
                          <img
                            style={{
                              paddingLeft: "4px",
                              pointerEvents:
                                item.is_verified === 0 ? "none" : "auto",
                              opacity: item.is_verified === 0 ? 0.5 : 1,
                              cursor:
                                item.is_verified === 0
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                            src={showDoc}
                            alt="showDoc"
                            onClick={() => {
                              if (item.is_verified !== 0) {
                                nextPage1(item.payment_receipt_id);
                              }
                            }}
                          />
                          {item.is_verified !== 1 && (
                            <button
                              onClick={() => deleteDoc(item.payment_receipt_id)}
                              style={{
                                height: "35px",
                                width: "35px",
                                marginLeft: "5px",
                                backgroundColor: "#F4616F",
                                borderColor: "#FF0000",
                              }}
                            >
                              <DeleteOutlinedIcon className="icon" />
                            </button>
                          )}
                          
                        </td>
                      }
                    </tr>
                  </table>
                </div>
                <div
                  style={{
                    position: "relative",
                    top: "-48px",
                    left: "8px",
                    width: "13%",
                    padding: "12px",
                    backgroundColor: transactionStyleMap[item.transaction_type_name]?.bg || "#f0f0f0",
                    borderRadius: "8px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    textAlign: "center"
                  }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: "13px",
                      color: transactionStyleMap[item.transaction_type_name]?.text || "#000"
                    }}
                  >
                    {item.transaction_type_name}
                  </p>

                  <span
                    style={{
                      fontWeight: "700",
                      fontSize: "19px",
                      paddingLeft: "6px",
                      color: transactionStyleMap[item.transaction_type_name]?.text || "#000"
                    }}
                  >
                    ₹ {item.amount} /-
                  </span>
                </div>
              </>
            ))
            : null}
        </div>
      </Wrapper >

    </>
  );
};

export default LeadPaymentDetails;
